import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OnlyLoggedInGuard } from './guard/only-logged-in.guard';
import { AlreadyLoggedInGuard } from './guard/already-logged-in.guard';

import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { MatchComponent } from './match/match.component';
import { QuarantineComponent } from './quarantine/quarantine.component';
import { HistoryComponent } from './history/history.component';

export const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [AlreadyLoggedInGuard]},
  { path: 'home', component: HomeComponent, canActivate: [OnlyLoggedInGuard] },
  { path: 'match', component: MatchComponent, canActivate: [OnlyLoggedInGuard] },
  { path: 'quarantine', component: QuarantineComponent, canActivate: [OnlyLoggedInGuard] },
  { path: 'history', component: HistoryComponent, canActivate: [OnlyLoggedInGuard] }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    OnlyLoggedInGuard,
    AlreadyLoggedInGuard
  ],
  declarations: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts